import { ReactNode } from 'react'

import HistoryModal, { ReportsHistoryDefaultOptions } from 'app/common/ui-components/history-modal'
import PlainButtonAsLink from 'app/common/ui-next/plain-button-as-link'


const columnIdsList = ['title', 'date', 'options']
const columnNamesList = ['Название отчета', 'Дата', '\u00A0']
const alignLeft = { alignLeft: true }
const alignCenter = { alignCenter: true }
const alignRight = { alignRight: true }
const columnPropsList = [alignLeft, alignCenter, alignRight]


export type HistoryItem = {
  id: string
  title: string
  date: string
  sortable: number
  options: ReactNode
  email: string | null
  status: number
}

type Props = {
  toggleButtonTitle?: string
  items?: Array<HistoryItem>
  loading?: boolean
  onRequestHistory?: () => Promise<void> | void
  onSendFileToEmail: (reportId: number, email: string) => Promise<void>
  onDownloadFile: (reportId: number) => Promise<void>
  onCheckStatus: (reportId: number) => Promise<number | null>
  onDisplayStatusChange: (status: boolean) => void
}

const ReportHistoryTemplate = ({
  toggleButtonTitle = 'История загрузок',
  items = [],
  loading,
  onRequestHistory,
  onSendFileToEmail,
  onDownloadFile,
  onCheckStatus,
  onDisplayStatusChange,
}: Props) => {
  return (
    <HistoryModal
      title="Последние 10 загрузок"
      columnIdsList={columnIdsList}
      columnNamesList={columnNamesList}
      columnPropsList={columnPropsList}
      itemsList={items}
      loading={loading}
      onRequestHistory={onRequestHistory}
      onDisplayStatusChange={onDisplayStatusChange}
      renderCellContent={(columnId, item) => {
        if (columnId === 'options') {
          const { id, email, status } = item
          const reportID = parseInt(id, 10)
          return (
            <ReportsHistoryDefaultOptions
              reportId={reportID}
              email={email}
              status={status}
              onSendFileToEmail={onSendFileToEmail}
              onDownloadFile={onDownloadFile}
              onCheckStatus={onCheckStatus}
            />
          )
        }
        return item[columnId]
      }}
    >
      {toggle => (
        <PlainButtonAsLink onClick={toggle}>
          {toggleButtonTitle}
        </PlainButtonAsLink>
      )}
    </HistoryModal>
  )
}

export default ReportHistoryTemplate
